export const images = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733491/travesia/wuuyxpptyk77v18f3p35.jpg",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733492/travesia/ro9a5nxnnd5zagw25auc.jpg",
  },

  {
    id: 3,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733492/travesia/uhwsxiapwehfiwvh00fu.jpg",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1747682863/travesia/ddsujzbvtrckctw1gbip.jpg",
  },
  {
    id: 5,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733492/travesia/uqwvg0hwctruabe4a9fl.jpg",
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733493/travesia/x1cj5w7lvrpkzmpm83tz.jpg",
  },
];

export const imgHeaderTravesiaCatedral =
  "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733493/travesia/nhahl6ftr4krivrogkqz.jpg";

export const tabletImages = [
  "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733494/travesia/hdcy8ecgfoezcecytdjt.jpg",
  "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733494/travesia/ryfau2kgyxztpizxws2x.jpg",
];

export const imgUno =
  "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733493/travesia/nhahl6ftr4krivrogkqz.jpg";
